import { i18n } from '@/plugins/i18n';
import VitalityCriterion from '@/utils/classes/VitalityCategory/VitalityCriterion';


/**
 * Score based on participation to meetings
 */
export default new VitalityCriterion({
  titleTr: 'VH_M_PARTICIPANTS',
  key: 'meetingParticipants',
  weight: 2,

  score: ({ meetings }, range) => {
    const filtered = meetings.filter(m => range.start.isBefore(m.date) && range.end.isAfter(m.date));
    let nExpectedParticipants = 0;
    let nParticipants = 0;

    const nMeetings = filtered.length;
    for (let i = 0; i < nMeetings; i++) {
      const { participants } = filtered[i];
      nExpectedParticipants += participants.length;
      nParticipants += participants.filter(p => p.attended === 1).length;
    }

    const noMeetings = nMeetings === 0;
    const score = noMeetings ? 0 : nParticipants * 100 / nExpectedParticipants;
    return {
      score,
      data: {
        score,
        nParticipants,
        nExpectedParticipants,
        noMeetings,
      },
    };
  },

  text: ({ score, noMeetings }) => {
    if (noMeetings) {
      return i18n.t('message.VH_M_NO_MEETING');
    }
    return i18n.t('message.VH_M_PARTICIPANTS_TEXT', { score: score.sToFixed(0) });
  },

});
